import React from 'react';
import styled from 'styled-components';
import Header from './header';
import Footer from './footer';
import { bannerBackground, doctor02 } from '../../constants/images';
import { BreadCrumb } from '../common/breadcrumb';

interface AuthPageProps {
    children: React.ReactNode;
    title: string;
}

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: url(${bannerBackground}),linear-gradient(rgba(255, 255, 255, 0.773), #d5e7fe) no-repeat center center;
    background-size: auto;
`;

const Content = styled.main`
    flex: 1;
    display: flex;
    justify-content: center;
`;

const ContentPage: React.FC<AuthPageProps> = ({ children,title }) => {
    return (
        <PageContainer>
            <Header />
            <BreadCrumb title={title} />
            <Content className='main-wrapper home-one'>
                {children}
            </Content>
            <Footer />
        </PageContainer>
    );
};

export default ContentPage;